import Section from 'components/base/Section';

import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Props } from './profile.type';
import { routeMapping } from './config';

function Profile({ mode }: Props) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname === routeMapping[mode].home) {
      navigate(routeMapping[mode].view);
    }
  }, [pathname]);
  return (
    <div className="pt-5 mb-9">
      <Section small className="py-0">
        <Outlet />
      </Section>
    </div>
  );
}

export default Profile;
